import React from 'react';
import { bool, node, string } from 'prop-types';
import { classNames } from 'primereact/utils';
import AUIIcon from '@ancert/aui-icon';
import { ESTADO_DENUNCIA } from '../../lib/denuncia.enum';

const DialogBox = ({ children, date, isSend, status, subtitle, time, title, isRequired }) => {
  const className = classNames('c-sii-dialog-box', {
    [`c-sii-dialog-box--send`]: isSend,
    [`c-sii-dialog-box--finished`]: !isSend && ESTADO_DENUNCIA.FINALIZADA === status,
    [`c-sii-dialog-box--rejected`]: !isSend && ESTADO_DENUNCIA.DESESTIMADA === status,
  });
  return (
    <div>
      <div className={className}>
        <header className="c-sii-dialog-box__header">
          <div className="c-sii-dialog-box__title">{title}</div>
          {subtitle && <div className="c-sii-dialog-box__subtitle">{subtitle}</div>}
        </header>
        <div className="c-sii-dialog-box__content">{children}</div>
        <footer className="c-sii-dialog-box__footer">
          <span>{date}</span>
          <span>{time}</span>
        </footer>
      </div>
      {isRequired && (
        <div className="c-sii-box-warning">
          <AUIIcon icon="error" color="white" />
          <p className="c-sii-box-warning__desc">
            Se requiere una respuesta en un plazo máximo de 5 días. Si no responde en este plazo, la denuncia pasara a
            ser <b>desestimada</b>.
          </p>
        </div>
      )}
    </div>
  );
};
DialogBox.propTypes = {
  children: node,
  isRequired: bool,
  date: string,
  isSend: bool,
  status: string,
  subtitle: string,
  time: string,
  title: string,
};
DialogBox.defaultProps = {
  children: null,
  date: '',
  isSend: false,
  status: '',
  subtitle: '',
  time: '',
  title: '',
  isRequired: false,
};

export default DialogBox;
